<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Jenis Barang</h5>
            </template>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="ml-2 mr-2"
                            v-model="filter" name="filterTable"
                            id="filterInput"
                            type="search"
                            placeholder="Type to search"
                            @keyup.enter="onFilter(filter)"
                        ></b-form-input>
                        <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter(filter)"> 
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
                    </div>
                </b-form-group>
                <div>
                    <b-button class="mb-3 mr-2" variant="pgiBtn" name="jenisBarangAddBtn" @click="inputJenisBarang">Input Jenis Barang</b-button>
                    <b-link :to="`${$route.path}/edit-kondisi-merk-elektronik`">
                        <b-button class="mb-3 mr-2" variant="pgiBtn" name="jenisBarangAddBtn">Edit Kondisi Elektronik</b-button>
                    </b-link>
                    <b-link :to="`${$route.path}/edit-kondisi-merk-kendaraan`">
                        <b-button class="mb-3" variant="pgiBtn" name="jenisBarangAddBtn">Edit Kondisi Kendaraan</b-button>
                    </b-link>
                </div>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="jenisBarang"
                :fields="fields" 
                :currentPage="currentPage" 
                :perPage="perPage"
                @filtered="onFiltered"
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data jenis barang.
                </template>
                <template v-slot:cell(kelengkapan)="row">
                    <ul class="list-none-wrapper" v-if="row.item.kelengkapan.length > 0">
                        <li v-for="kelengkapan in row.item.kelengkapan" v-bind:key="kelengkapan.id">
                            <span> 
                                <i class="fa fa-check" v-if="(kelengkapan.isActive == true)"></i>
                                <i class="fa fa-times" v-if="(kelengkapan.isActive == false)"></i>
                                {{kelengkapan.name}}
                            </span>
                        </li>
                    </ul>
                    <span v-else>-</span>
                </template>
                <template v-slot:cell(status)="row">
                    <div class="no-wrap">
                        <b-badge variant="success" v-if="row.item.isActive == true">AKTIF</b-badge>
                        <b-badge variant="danger" v-else>NON-AKTIF</b-badge>
                        <!-- <b-button size="sm" class="ml-2 table-button edit" v-b-tooltip.hover title="Ganti Status" name="btnEditStatus" @click="openModalEditStatus(row.item.id)">
                            <i class="fa fa-pencil-square-o"></i>
                        </b-button> -->
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}`">
                            <b-button size="sm" class="mr-3 table-button view" v-b-tooltip.hover title="Detail" name="jenisBarangViewBtn">
                                <i class="fa fa-info"></i>
                            </b-button>
                        </b-link>
                        <b-link :to="`${$route.path}/${row.item.id}/edit`">
                            <b-button size="sm" class="mr-3 table-button edit" v-b-tooltip.hover title="Edit" name="jenisBarangEditBtn">
                                <i class="fa fa-pencil-square-o"></i>
                            </b-button>
                        </b-link>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'master-jenis-barang',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10
            },
            fields: [
                { key: "name", label: "Jenis Barang", sortable:true},
                { key: "jenisPinjaman.name", label: "Tipe Pinjaman", sortable:true},
                { key: "kelengkapan", label: "Kelengkapan Barang" },
                { key: "status", label: "Status"},
                { key: "action", label: "Aksi"},
            ],
            filter: null,
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            jenisBarangAll: [],
            jenisBarang: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: ''
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0

            let getJenis = this.$axios.get("barang-jenis/").then(response => {
                // this.jenisBarang = []
                // this.jenisBarangAll = []
                this.jenisBarangAll = response.data
                this.jenisBarang = response.data
                // for(var data of response.data){
                //     if(data.isActive == true){
                //         this.jenisBarang.push(data)
                //         this.jenisBarangAll.push(data)
                //     }
                // }
                this.updateTotalItem()
            })

            Promise.all([getJenis]).then(() => {
                this.initStatus = 1
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        //-----------------  Fungsi Ambil Data Jenis Barang ----------------- 

        getJenis(){
            this.jenisBarang = this.jenisBarangAll
            this.toggleBusy()
            this.updateTotalItem()
        },


        //----------------- Fungsi Pagination, Sorting, dan Filtering -----------------
        
        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },

        onFilter(letters){
            
            if(this.filter == null){
                this.$helper.toastErr(this, "Silakan isi nama jenis barang terlebih dahulu!")
            }else{
                let filteredArray = []

                for (var x of this.jenisBarangAll) {
                    if(x.name.toLowerCase().includes(letters.toLowerCase())){
                        filteredArray.push(x)
                    }
                }
                
                this.jenisBarang = filteredArray
                this.onFiltered(this.jenisBarang)
            }
        },

        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
            this.perPage = this.input.show
            let prevLimit = null
            let limit = null
            
            prevLimit = (this.currentPage-1) * this.rows + 1
            limit = (this.currentPage-1) * this.rows + this.rows
            if (limit > this.input.show) limit = this.input.show
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onReset(){
            this.filter = ""
            this.toggleBusy()
            this.getJenis()
        },
        

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(){
            this.rows = this.jenisBarang.length
            if (this.perPage > this.rows) this.perPage = this.rows
            this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
        },

        inputJenisBarang(){
            this.$router.push({path: `${this.$route.path}/input`});
        },
    },

    created(){
        this.init()
    }
}
</script>
